import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PrimeReactProvider, addLocale, locale } from 'primereact/api';
/* Bootstrap: samo reboot (normalizacija); raspored i kontrole su naši + PrimeReact. */
import 'bootstrap/dist/css/bootstrap-reboot.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
/* PrimeReact tema (svetla/tamna) se učitava kroz <link id="theme-link"> u public/index.html — vidi src/theme.js. */
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './index.css';
import App from './App';
import { store } from './store';
import { AlertProvider } from './custom/Alerts';
import { SR_LOCALE } from './utils/dates';

addLocale('sr', SR_LOCALE);
locale('sr');

ReactDOM.createRoot(document.getElementById('root')).render(
    <Provider store={store}>
        {/* locale mora i ovde: PrimeReactProvider bez vrednosti postavlja 'en' i poništava globalni locale('sr') */}
        <PrimeReactProvider value={{ locale: 'sr' }}>
            <BrowserRouter>
                <AlertProvider>
                    <App />
                </AlertProvider>
            </BrowserRouter>
        </PrimeReactProvider>
    </Provider>
);
